<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
					<v-btn
						icon
						dark
						small
						color="#959595"
						class="mr-2"
						v-bind="{ ...tooltipAttrs, ...menuAttrs }"
						v-on="{ ...tooltipOn, ...menuOn }"
					>
						<v-icon dark>mdi-file-clock-outline</v-icon>
					</v-btn>
				</template>
				<span>Historial de PDFs del Informe</span>
			</v-tooltip>
		</template>
		<v-list dense class="py-0 white">
			<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
				<div>
					<p class="caption mb-0 font-weight-bold white--text">Historial del Informe Nº {{ report.prefix?.prefix }} {{ report.serial_id }} - {{ report.created_at | toYear }}</p>
				</div>
			</v-list-item>
			<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
				<div class="d-flex align-center flex-grow-1">
					<p class="caption mb-0 text--disabled" style="width: 100px;">Estado</p>
					<p class="caption mb-0 text--disabled" style="width: 120px;">Fecha</p>
					<p class="caption mb-0 text--disabled" style="width: 70px;">Acción</p>
				</div>
			</v-list-item>
			<v-divider></v-divider>
			<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
				<v-list-item
					v-for="(reportPdf, index) in report.pdf_history"
					:key="'bpdfhistory-'+index"
					dense
					style="min-width: 320px;"
					class="white"
					@click="$store.commit('reports/setReportPdfModal', {...report, ...{forced_pdf: reportPdf}})"
				>
					<v-list-item-title dense>
						<div class="d-flex align-center item-background-hover">
							<div class="d-flex align-center caption"  style="width: 100px;">
								<v-icon class="mr-1" x-small :color="reportStatusColor(reportPdf?.report_status?.status)">mdi-circle</v-icon>
								<b>{{reportPdf.report_status?.status | budgetStatus}}</b>
							</div>
							<div class="d-flex align-center caption" style="width: 120px;">
								<p class="mb-0 caption text-end">{{reportPdf.created_at | toDateTime}}</p>
							</div>
							<div class="d-flex align-center caption" style="width: 70px;">
								<v-btn
									text
									x-small
									@click="$store.commit('reports/setReportPdfModal', {...report, ...{forced_pdf: reportPdf}})"
								>
									<p class="mb-0 caption">Ver PDF</p>
								</v-btn>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>

<script>
export default {
  name: 'ReportPdfHistory',
  components: { },
	props: {
		report: {
			type: Object,
			required: true
		}
	},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
    newBudgetCategory: {
			category_id: null,
			name: null
    },
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
  },
  methods: {
		reportStatusColor(reportStatus){
			return this.$options.filters.budgetStatusColor(reportStatus)
		},
  }
};
</script>